import type { Span } from '@opentelemetry/api'
import type { SpanProcessor } from '@opentelemetry/sdk-trace-base'
import * as Sentry from '@sentry/react'

import { ATTR_SENTRY_REPLAY_URL } from './spanAttributes'

export class SentryLinkSpanProcessor implements SpanProcessor {
  private sentryOrgSlug: string

  constructor(sentryOrgSlug: string) {
    this.sentryOrgSlug = sentryOrgSlug
  }

  onStart(span: Span): void {
    const replayId = Sentry.getReplay()?.getReplayId()
    if (replayId) {
      span.setAttribute(
        ATTR_SENTRY_REPLAY_URL,
        `https://sentry.io/organizations/${this.sentryOrgSlug}/replays/${replayId}/`
      )
    }
  }

  onEnd(): void {}

  forceFlush(): Promise<void> {
    return Promise.resolve()
  }

  shutdown(): Promise<void> {
    return Promise.resolve()
  }
}
